import { DASH } from '@/lib/template-stats';

/** A formatted stat; the dash that stands for "nothing to count" reads muted, like the product's table placeholders. */
export function StatText({ value }: { value: string }) {
  return value === DASH ? <span className="text-muted-foreground">{DASH}</span> : <>{value}</>;
}
